import React, { Fragment, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { notBlank } from "../../../util/ext";
import clsx from "clsx";
import { concat, descend, equals, join, prop, sort, uniqBy } from "ramda";
import { OrganizeViews } from "../organizeUtil";
import { useCreatorModules } from "../../creatorServices";
import { useSearchQuery } from "../../common/use-searchQuery";
import { useSelected } from "../OrganizeProvider";

import Button from "@material-ui/core/Button";
// import SidebarModuleSearchBar from "./SidebarModuleSearchBar";
import SidebarModuleTreeItem from "./SidebarModuleTreeItem";
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles(theme => ({
  avatar: {
    height: 25,
    width: 25,
  },

  badge: {
    width: 16,
    height: 16,
    borderRadius: 20,
    marginLeft: 0,
  },

  highlight: {
    fontWeight: "bold",
    color: theme.palette.brandPrimary,
  },

  published: {
    backgroundColor: "green",
  },

  tooltip: {
    borderRadius: "20px",
    padding: "5px 12px",
    margin: "0",
  },

  unpublished: {
    backgroundColor: "#999",
  },
}));

// const HighlightedName = props => {
//   const { text, query, highlightClass } = props;

//   const searchRegEx = new RegExp(`(${query})`, "gi");
//   const parts = text.split(searchRegEx);

//   return (
//     <Fragment>
//       {parts.map((part, i) => {
//         const highlightStyle = equals(toLower(part), toLower(query))
//           ? highlightClass
//           : "";
//         return (
//           <span key={i} className={highlightStyle}>
//             {part}
//           </span>
//         );
//       })}
//     </Fragment>
//   );
// };

const buildModuleNodeId = moduleId =>
  join("-", [
    OrganizeViews.ORGANIZE,
    OrganizeViews.CONTENT_GROUPS,
    OrganizeViews.MODULE,
    moduleId,
  ]);

const initialModulesState = {
  page: 0,
  limit: 10,
  orderBy: "auditUpdated",
  orderDirection: "desc",
  status: "ACTIVE,INACTIVE",
};

const sortByLastUpdated = sort(descend(prop("auditUpdated")));

const SidebarModuleTree = props => {
  const classes = useStyles();
  const { setLoading, showAlert, onLabelClick } = props;
  const { removeAllSelected } = useSelected();

  const modulesQuery = useSearchQuery(initialModulesState);
  const [modulesQueryState, setModulesQueryState] = useState({
    limit: initialModulesState.limit,
    offset: modulesQuery.state.limit * modulesQuery.state.page,
    sort: `${modulesQuery.state.orderBy} ${modulesQuery.state.orderDirection}`,
    status: initialModulesState.status,
  });
  useEffect(() => {
    const { limit, page } = modulesQuery.state;
    setModulesQueryState(prev => ({ ...prev, offset: limit * page }));
  }, [modulesQuery.state]);

  const creatorModules = useCreatorModules(modulesQueryState);
  const [modules, setModules] = useState([]);
  useEffect(() => {
    if (creatorModules.isSuccess) {
      setModules(prev => {
        const previous = modulesQuery.state.page === 0 ? [] : prev;
        const modules = concat(previous, creatorModules.data.contents);
        return sortByLastUpdated(uniqBy(prop("id"), modules));
      });
    }
  }, [modulesQuery.state, creatorModules.isSuccess, creatorModules.data]);

  useEffect(() => {
    setLoading(creatorModules.isLoading);
  }, [creatorModules.isLoading, setLoading]);

  return (
    <Fragment>
      {/* {notBlank(modules) && modules.length > 10 && (
        <SidebarModuleSearchBar
          query={searchState.appliedQuery}
          onQueryChange={onQueryChange}
        />
      )} */}

      {notBlank(modules) &&
        modules.map(module => (
          <SidebarModuleTreeItem
            key={buildModuleNodeId(module.id)}
            nodeId={buildModuleNodeId(module.id)}
            module={module}
            showAlert={showAlert}
            onClick={() => removeAllSelected()}
            onLabelClick={onLabelClick(module.id)}
            tooltipLabel={module.name}
            label={module.name}
            // label={
            //   <HighlightedName
            //     text={module.name}
            //     query={
            //       notBlank(searchState.appliedQuery)
            //         ? searchState.appliedQuery[0]
            //         : ""
            //     }
            //     highlightClass={classes.highlight}
            //   />
            // }
            icon={
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                title={module.status === "ACTIVE" ? "Live" : "Draft"}
                placement="left"
              >
                <div
                  className={clsx(classes.badge, {
                    [classes.published]: equals(module.status, "ACTIVE"),
                    [classes.unpublished]: !equals(module.status, "ACTIVE"),
                  })}
                />
              </Tooltip>
            }
          />
        ))}

      {creatorModules.isSuccess && creatorModules.data.hasMore && (
        <Button
          style={{ width: "95%" }}
          onClick={() =>
            modulesQuery.handleUpdatePage(modulesQuery.state.page + 1)
          }
        >
          More
        </Button>
      )}
    </Fragment>
  );
};

export default SidebarModuleTree;
